
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class ModalVideo extends Vue {

  /* PROP */

  @Prop({default: false})
  private isShow: boolean;

  @Prop({default: ''})
  private vidioId: string;

  @Watch('isShow')
  private onChanged(val: any) {
    if (val) {
      this.player.playVideo();
    }
  }

  private player: any;

  constructor() {
    super();
  }

  private videoReady(event: any) {
      this.player = event.target;
  }
  private closeModal() {
      this.player.stopVideo();
      this.$emit('update:isShow', false);
  }
}
